import { Reducer } from "redux";

import { ScorecardBaselineTableResponse } from "../models/api/Scorecard";
import { ScorecardBaselineTableDispatchTypes } from "../models/dispatchTypes/Scorecard";
import { GetScorecardBaselineTableActionDispatchTypes } from "../constants/Scorecard";

const initialState: ScorecardBaselineTableResponse = {
  loading: false,
  response: null,
  error: null,
};

const ScorecardBaselineTableReducer: Reducer<
  ScorecardBaselineTableResponse,
  ScorecardBaselineTableDispatchTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case GetScorecardBaselineTableActionDispatchTypes.GET_SCORECARD_BASELINE_TABLE_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case GetScorecardBaselineTableActionDispatchTypes.GET_SCORECARD_BASELINE_TABLE_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
    case GetScorecardBaselineTableActionDispatchTypes.GET_SCORECARD_BASELINE_TABLE_ERROR: {
      return {
        ...state,
        error: action.error,
        response: null,
        loading: false,
      };
    }
    case GetScorecardBaselineTableActionDispatchTypes.GET_SCORECARD_BASELINE_TABLE_RESET: {
      return initialState;
    }
  }
  return state;
};

export default ScorecardBaselineTableReducer;
